export const SettingsPage = () => {
  return (
    <div className="grid w-full gap-2 p-8">
      <h1 className="mb-4 text-2xl font-extrabold tracking-tight">Settings</h1>
      Under construction
    </div>
  );
};
